import { FILES_URL } from '@/shared/lib/utils/constants/const'

import cl from './style.module.scss'

export const RuleNotation = () => {
	return (
		<p className={cl.rights}>
			Вводя код, я подтверждаю, что прочитал(а), ознакомился(лась) и согласен(на) с
			<a
				href={`${FILES_URL}/NBC_web-policy.pdf`}
				title="Ознакомиться с политикой конфиденциальности (pdf)"
				target="_blank">
				{' политикой конфиденциальности '}
			</a>
			и
			<a
				href={`${FILES_URL}/NBC_web-consest.pdf`}
				title="Ознакомиться с согласием на обработку персональных данных (pdf)"
				target="_blank">
				{' обработкой персональных данных '}
			</a>
		</p>
	)
}
